import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=93ed65d8&"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=93ed65d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports